<script lang="ts">
  export let rating: number
</script>

<div class="auws-rating-dots">
  {#each [0, 1, 2, 3, 4] as dot}
    <span
      class="auws-rating-dot"
      data-rating={rating && dot < rating ? rating : null}
    />
  {/each}
</div>

<style>
  .auws-rating-dots {
    display: flex;
    gap: 4px;
  }

  .auws-rating-dots .auws-rating-dot {
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #d4e3f5;
  }

  .auws-rating-dots .auws-rating-dot[data-rating="1"] {
    background-color: #ba1717;
  }

  .auws-rating-dots .auws-rating-dot[data-rating="2"] {
    background-color: #f07f23;
  }

  .auws-rating-dots .auws-rating-dot[data-rating="3"] {
    background-color: #56ac82;
  }

  .auws-rating-dots .auws-rating-dot[data-rating="4"] {
    background-color: #68a52e;
  }

  .auws-rating-dots .auws-rating-dot[data-rating="5"] {
    background-color: #3a835f;
  }
</style>
